exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".controls_controls-container_3ZRI_ {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.controls_controlBtn_1sUti {\n    padding: 0 20px 0 20px;\n}\n\n.controls_controlBtn_1sUti img {\n    margin: 0 10px 0 10px;\n}\n", ""]);

// exports
exports.locals = {
	"controls-container": "controls_controls-container_3ZRI_",
	"controlsContainer": "controls_controls-container_3ZRI_",
	"controlBtn": "controls_controlBtn_1sUti"
};